export function currency(value: string | number, digits: number = 0) {
  const formatter = new Intl.NumberFormat("en-au", {
    style: "currency",
    currency: "aud",
    minimumFractionDigits: digits,
  });
  const v: number = value ? parseFloat(value.toString()) : 0;
  return formatter.format(v);
}
